import { ViewChild, Component, EventEmitter, ElementRef, AfterViewInit, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import saveAs from 'file-saver';
import { takeUntil } from 'rxjs';
import { PropertyItemDocumentPurposeEnumHelper } from '../../Models/OtherClasses';
import { BaseBusyableComponent } from '../../Services/BaseBusyableComponent';
import { ConfigService } from "../../Services/ConfigService";
import { PropertyItemDocumentService } from '../../Services/Custom/ServicePropertyItemDocument';
import { ImagePopUpComponent } from '../PopUps/ImagePopUpComponent';
import { Router } from '@angular/router';
import { DateTime } from 'luxon';
import { PropertyItemDocumentPurposeEnum } from '../../Models/Interfaces/PropertyItemDocumentPurposeEnum';


@Component({
	selector: 'PropertyItemImage',
	templateUrl: 'PropertyItemImage.html',

})
export class PropertyItemImageComponent extends BaseBusyableComponent implements OnInit, AfterViewInit, OnDestroy {

	ngAfterViewInit(): void {
		if (this.myImgObj) {
			this.myImgObj.nativeElement.style.maxHeight = this._maxHeight;
		}
	}

	ngOnDestroy(): boolean {
		return super.ngOnDestroy();
	}

	ngOnInit(): void {

	}
	constructor(public configData: ConfigService,
		private mymodalService: NgbModal,
		private myRouter: Router,
		private myPropertyItemDocumentService: PropertyItemDocumentService,
	) {
		super();
	}

	@ViewChild('mainImage') myImgObj: ElementRef;

	@Input() allowLabelChanges = true;

	@Output() deleted = new EventEmitter<TooBig4Car.Logic.PropertyItemDocument>();

	@Output() rotated = new EventEmitter<TooBig4Car.Logic.PropertyItemDocument>();

	@Output() labelChanged = new EventEmitter<TooBig4Car.Logic.PropertyItemDocument>();

	thumbBase64 = '';

	makePhotoHolder() {
		if (this.myDoc) {
			this.myDoc.photoHolder = {};
			if (this.configData.IsEmptyGuid(this.myDoc.PickupDeliveryID)) {
				this.myDoc.photoHolder.vals = PropertyItemDocumentPurposeEnumHelper.getPropertyItemImages(false);
			} else {
				this.myDoc.photoHolder.vals = PropertyItemDocumentPurposeEnumHelper.getPickupDeliveryImages();
			}

			this.myDoc.photoHolder.vals.forEach((pEnum: any) => {
				pEnum.IsSelected = this.hasEnum(pEnum.Value);
			})
		}
	}

	overlayText = '';
	loadOverlay() {
		this.overlayText = '';
		if (this.myDoc && !this.isPickupDeliveryItem) {
			this.overlayText = this.myDoc.OverlayText;
		}
	}

	get needsRedBorder(): boolean {
		return this.hasEnum(PropertyItemDocumentPurposeEnum.DamageImage);
	}

	hasEnum(pEnum: number): boolean {
		if (this.myDoc) {
			return (this.myDoc.ImagePurpose & pEnum) != 0;
		}
		return false;
	}

	get isPickupDeliveryItem() {
		return !this.configData.IsEmptyGuid(this.myDoc.PickupDeliveryItemID);
	}
	loadPopUp(popControl: NgbPopover) {
		if (this.canUpload) {
			if (!this.isPickupDeliveryItem) {
				this.makePhotoHolder();
				popControl.open();
				return;
			}
		}
		this.downloadDoc(popControl);
	}

	rotateAllowed() {
		return this.myDoc?.APICanIEditThis && this.myDoc?.IsImage;
	}
	deleteAllowed() {
		return this.myDoc?.APICanIDeleteThis;
	}
	rotateDoc() {
		var thisHolder = this;
		if (thisHolder.rotateAllowed()) {
			thisHolder.dialogService.confirm('Are you sure?')
				.then(result => {
					thisHolder.myPropertyItemDocumentService.rotate(thisHolder.myDoc.PropertyItemDocumentID)
						.subscribe(val => {
							thisHolder.rotated.next(thisHolder.myDoc);
							thisHolder.thumbBase64 = '';
							thisHolder.myDoc.base64Content = '';
							thisHolder.loadImageStuff(DateTime.now().second.toString());
						});
				});
		}
	}
	deleteDoc() {
		var thisHolder = this;
		if (thisHolder.deleteAllowed()) {
			thisHolder.dialogService.confirm('Are you sure?')
				.then(result => {
					thisHolder.myPropertyItemDocumentService.deleteItem(thisHolder.myDoc.PropertyItemDocumentID)
						.subscribe(val => {
							thisHolder.deleted.next(thisHolder.myDoc);
						});
				});
		}
	}

	togglePurpose(popControl: NgbPopover) {

		if (this.myDoc.IsImage && this.myDoc.photoHolder?.vals && this.allowLabelChanges) {
			var col: any[] = this.myDoc.photoHolder.vals;
			var enums = col.filter(a => a.IsSelected).map(a => a.Value);
			this.myPropertyItemDocumentService.togglePurpose(this.myDoc.PropertyItemDocumentID, enums)
				.pipe(takeUntil(this.obsToCloseSubject))
				.subscribe(pDoc => {
					this.myDoc.ImagePurpose = pDoc.ImagePurpose;
					this.myDoc.OverlayText = pDoc.OverlayText;
					this.loadOverlay();
					this.labelChanged.next(this.myDoc);
					if (popControl) {
						popControl.close(true);
					}
				});
		}
	}

	downloadDoc(popControl: NgbPopover) {
		if (popControl) {
			popControl.close(true); 
		}
		if (this.myDoc.IsImage) {
			var thisHolder = this;
			this.myPropertyItemDocumentService.downloadDoc(this.myDoc.PropertyItemDocumentID)
				.pipe(takeUntil(this.obsToCloseSubject))
				.subscribe(file => {
					var modal = thisHolder.mymodalService.open(ImagePopUpComponent, {size: 'xl'});
					var col = this.myPropItemCol.map(a => a.PropertyItemDocumentID);
					var idx = col.indexOf(this.myDoc.PropertyItemDocumentID);
					modal.componentInstance.setBlob(file, idx, this.myPropItemCol);
				});
		} else if (this.myDoc.IsPdf) {
			//https://careydevelopment.us/blog/angular-how-to-open-a-link-in-a-new-tab
			var url = this.myRouter.serializeUrl(this.myRouter.createUrlTree(['viewer', this.myDoc.PropertyItemDocumentID]));
			window.open(url, '_blank');
		} else {
			this.isSaving = true;
			this.myPropertyItemDocumentService.downloadDoc(this.myDoc.PropertyItemDocumentID)
				.pipe(takeUntil(this.obsToCloseSubject))
				.subscribe(file => {
					saveAs(file.blob, file.fileName);
					this.isSaving = false;
				});
		}
	}

	loadImageStuff(qs: string) {
		this.myDoc.photoHolder = {
			vals: []
		};
		var thisHolder = this;
		if (!thisHolder.thumbBase64) {
			if (thisHolder.myDoc?.IsImage && thisHolder.myDoc?.base64Content) {
				thisHolder.thumbBase64 = thisHolder.myDoc?.base64Content;
			}
			if (!thisHolder.thumbBase64) {
				if (!thisHolder.configData.IsEmptyGuid(thisHolder.myDoc.PropertyItemDocumentID)) {
					thisHolder.myPropertyItemDocumentService.downloadThumb(thisHolder.myDoc.PropertyItemDocumentID, qs)
						.pipe(takeUntil(thisHolder.obsToCloseSubject))
						.subscribe(file => {
							thisHolder.configData.blobToBase64(file.blob)
								.then(dataStr => {
									thisHolder.thumbBase64 = dataStr;
								});

						});
				}
			}
		}
	}
	@Input()
	set doc(val: TooBig4Car.Logic.PropertyItemDocument) {
		if (val) {
			if (val.PropertyItemDocumentID != this.myDoc.PropertyItemDocumentID) {
				this.myDoc = val;
				this.loadImageStuff('');
				this.loadOverlay();
			}
		}
	}
	get doc(): TooBig4Car.Logic.PropertyItemDocument {
		return this.myDoc;
	}
	myDoc = {
		photoHolder: {
			vals: []
		}
	} as TooBig4Car.Logic.PropertyItemDocument;

	_maxHeight = '';
	@Input()
	set maxHeight(val: string) {
		this._maxHeight = val;
		
	}

	@Input()
	set propItemCol(val: TooBig4Car.Logic.PropertyItemDocument[]) {
		if (val) {
			this.myPropItemCol = val.filter(a => a.IsImage);
		} else {
			this.myPropItemCol = [];
		}
	}
	get propItemCol(): TooBig4Car.Logic.PropertyItemDocument[] {
		return this.myPropItemCol;
	}
	myPropItemCol: TooBig4Car.Logic.PropertyItemDocument[] = [];

	@Input()
	set canUpload(val: boolean) {
		this._canUpload = val;
	}
	get canUpload(): boolean {
		return this._canUpload;
	}
	_canUpload = false;

} 
